// @flow
import {Coorganization, UnmappedCoorganization} from "./types";

export const mapCoorganizations: Coorganization = (datum: UnmappedCoorganization) => {
    if (!datum) return
    return {
        description: {
            en: datum.DescriptionEN ?? '',
            el: datum.DescriptionEL ?? '',
        },
        mainExhibition: {
            en: datum.MainExhibitionDescriptionEN ?? '',
            el: datum.MainExhibitionDescriptionEL ?? '',
        },
        mainExhibitionId: datum.MainExhibitionId ?? '',
        id: datum.id ?? '',
        orderById: Number(datum.id) ?? '',
        exhibitionsIds: datum.ids ?? [],
    }
}